import { Link } from "react-router-dom";

const secret = [
  { label: "剧场版专区", icon: "ri-film-line" },
  { label: "OVA 番外", icon: "ri-video-line" },
  { label: "冷门遗珠", icon: "ri-award-line" },
  { label: "年度神作", icon: "ri-vip-crown-2-line" },
];

export default function Secret() {
  return (
    <section id="secret" className="relative overflow-hidden scroll-mt-20">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20anime%20background%20of%20a%20mysterious%20glowing%20door%20in%20a%20dark%20library%20with%20floating%20book%20spirits%20and%20fireflies%2C%20warm%20amber%20and%20cream%20palette%2C%20cinematic%20cozy%20mystery%20mood%2C%20high%20detail%20painting&width=1600&height=800&seq=milk-secret&orientation=landscape"
        alt="牛奶动漫库 隐藏目录入口背景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/30"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 py-20 md:px-8 md:py-28">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-400/40 bg-accent-500/15 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-accent-400">
            <i className="ri-key-2-line"></i> Secret Catalog
          </span>
          <h2 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            隐藏目录
            <br />
            给资深番友的彩蛋入口
          </h2>
          <p className="mt-4 text-sm leading-7 text-background-200 md:text-base">
            有些好番不常出现在热门首页，它们藏在层层筛选之后。剧场版、OVA 番外、冷门遗珠——真正的宝藏，只给愿意多翻一层的人。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {secret.map((s) => (
              <Link
                key={s.label}
                to="/sousuo"
                className="group flex flex-col items-center gap-2 rounded-lg border border-background-50/15 bg-background-50/5 px-3 py-5 backdrop-blur transition-colors hover:border-accent-400/50 hover:bg-background-50/10"
              >
                <i className={`${s.icon} text-xl text-accent-400`}></i>
                <span className="text-sm text-background-100 group-hover:text-accent-300">{s.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}